module.exports = {"510114001":"大丰街道","510114003":"三河街道","510114004":"新都街道","510114102":"石板滩镇","510114103":"新繁镇","510114104":"新民镇","510114106":"泰兴镇","510114108":"斑竹园镇","510114109":"清流镇","510114111":"马家镇","510114112":"龙桥镇","510114114":"木兰镇","510114116":"军屯镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510114.json
// module id = 2260
// module chunks = 0